import Vue                    from "vue";
import { MediaService }       from "@/services/";
import { LoadingSpinner }     from "@/components";
import { ErrorLogService } from "@/services/ErrorLogService"
export default Vue.extend({
    name: "Carousel",
    props: {
        carouselAds: {}
    },
    components: {
      LoadingSpinner
    },
    data() {
      return {
        slide: 0,
        sliding: null,
        numberOfImagesLoaded: 0
      }
    },
    methods: {
      imageUrl: function (value: string | number) {
        return MediaService.getMediaUrl(value);
      },
      onSlideStart() {
        this.sliding = true
      },
      onSlideEnd() {
        this.sliding = false
      },
      incrementImageLoadCount(){
        this.numberOfImagesLoaded += 1;
      },
      removeErroredSlideFromCarousel(carouselAd: any){
        this.carouselAds = this.carouselAds.filter((c: any) => c.Id !== carouselAd.Id);
      },
      openInNewWindow: function (isExternalLink: Boolean) {
        return isExternalLink ? "_blank" : "_self";
      }
    }
});
